<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Admin Settings
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Government TLDs</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-building me-1" style="color: #00A0C1;"></i>
                  Globally defined master government top-level domains list.
               </small>
            </div>
         </div>
      </div>

      <GovernmentTlds />
   </div>
</template>

<script>
import GovernmentTlds from '@/components/Admin Controls/GovernmentTlds.vue';

export default {
   components: { GovernmentTlds },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>
